import { createEvent, restore } from 'effector-root'

export const setIsCheckTimeout = createEvent<boolean>()
export const $isCheckTimeout = restore(setIsCheckTimeout, false)
